import { create } from "zustand";
import { type AddedProductSnapshot } from "@/composites/cart/AddToCartSliderContent";

export type { AddedProductSnapshot };

export const SLIDER_REOPEN_DELAY_MS = 200;

interface AddToCartSliderStore {
	isOpen: boolean;
	addedProduct: AddedProductSnapshot | null;
	open: (product: AddedProductSnapshot) => void;
	close: () => void;
}

let reopenTimer: ReturnType<typeof setTimeout> | null = null;

export const useAddToCartSliderStore = create<AddToCartSliderStore>(
	(set, get) => ({
		isOpen: false,
		addedProduct: null,
		open: (product: AddedProductSnapshot): void => {
			const hasPendingReopen = reopenTimer !== null;
			if (reopenTimer) {
				clearTimeout(reopenTimer);
				reopenTimer = null;
			}

			if (!get().isOpen && !hasPendingReopen) {
				set({ isOpen: true, addedProduct: product });
				return;
			}

			set({ isOpen: false });
			reopenTimer = setTimeout(() => {
				reopenTimer = null;
				set({ isOpen: true, addedProduct: product });
			}, SLIDER_REOPEN_DELAY_MS);
		},
		close: (): void => {
			set({ isOpen: false });
		}
	})
);
